export default __webpack_public_path__ + "70680f43affc1108b9b00ea6bed4466f.png";